import { ContentViewedPageSource, contentViewedPageSource, routes } from '../constants';

// Followed collections (folge-ich) display curated collections the user
// follows, so they attribute as 'curated collections' (SEAR-683 spec).
const routeRootToPageSource: ReadonlyArray<[string, ContentViewedPageSource]> = [
  [routes.dashboard.root, contentViewedPageSource.dashboard],
  [routes.search.root, contentViewedPageSource.search],
  [routes.pinned.root, contentViewedPageSource.favourites],
  [routes.downloads.root, contentViewedPageSource.downloads],
  [routes.collections.root, contentViewedPageSource.myCollections],
  [routes.curatedCollections.root, contentViewedPageSource.curatedCollections],
  [routes.followed.root, contentViewedPageSource.curatedCollections],
  [routes.productPage.root, contentViewedPageSource.product],
];

/**
 * Maps the pathname where a material link is clicked to the Content Viewed
 * `page source` value. Pages outside the tracked list yield undefined — the
 * property is omitted for them.
 */
export const getPageSourceFromPathname = (pathname: string): ContentViewedPageSource | undefined => {
  const match = routeRootToPageSource.find(([root]) =>
    pathname === `/${root}` || pathname.startsWith(`/${root}/`));
  return match?.[1];
};
